<template>
    <div>
        <form @submit.prevent>
            <div class="kt-portlet__body">
                    <div class="form-group ">
                        <h2 class="title col-12">
                            {{ creating ? $t('AppOperatorsForm.Cadastrar Motorista') : $t('AppOperatorsForm.Editar Motorista') }}
                        </h2>
                    </div>

                    <div class="form-group">
                            <label> {{ $t('AppOperatorsForm.Nome') }} </label>
                            <app-input v-model="form.first_name" type="text" class="form-control"
                                       :class="{'is-invalid' : $v.form.first_name.$invalid && $v.form.first_name.$dirty}"/>
                            <span class="form-text error" v-if="$v.form.first_name.$invalid && $v.form.first_name.$dirty">
                               {{ $t('AppOperatorsForm.Nome obrigatório') }}
                            </span>
                    </div>
                    <div class="form-group">
                        <label> {{ $t('AppOperatorsForm.Sobrenome') }} </label>
                        <app-input v-model="form.last_name" type="text" class="form-control"
                                   :class="{'is-invalid' : $v.form.last_name.$invalid && $v.form.last_name.$dirty}"/>
                        <span class="form-text error" v-if="$v.form.last_name.$invalid && $v.form.last_name.$dirty">
                            {{ $t('AppOperatorsForm.Sobrenome obrigatório') }}
                        </span>
                    </div>
                    <div class="form-group">
                        <label> {{ $t('AppOperatorsForm.Cadastro') }} </label>
                        <app-input v-model="form.identification" type="text" class="form-control"/>
                    </div>
                    <div class="form-group">
                        <label> {{ $t('AppOperatorsForm.Celular') }} </label>
                        <app-input v-model="form.phone" type="text" v-mask="['(##) ####-####', '(##) #####-####']"
                                   class="form-control"/>
                    </div>
                    <div class="form-group">
                        <label> {{ $t('AppOperatorsForm.Selecione o estado') }} </label>
                        <Dropdown v-model="form.state" :options="statesAndCities" optionLabel="name" filter showClear
                                  @input="clearOrDisableCities" style="width: 100%">
                            <template #value="slotProps">
                                <div v-if="slotProps.value" class="country-item country-item-value">
                                    <div>{{slotProps.value.name}}</div>
                                </div>
                                <span v-else></span>
                            </template>
                            <template #option="slotProps">
                                <div class="country-item">
                                    <div>{{slotProps.option.name}}</div>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="form-group">
                        <label> {{ $t('AppOperatorsForm.Selecione a cidade') }} </label>
                        <Dropdown v-model="form.city" :options="citiesFromState" :disabled="!isStateSelected" showClear
                                  filter :filterPlaceholder="$t('AppOperatorsForm.Procurar')" style="width: 100%">
                            <template #value="slotProps">
                                <div v-if="slotProps.value">
                                    <div>{{slotProps.value}}</div>
                                </div>
                                <span v-else></span>
                            </template>
                            <template #option="slotProps">
                                <div class="country-item">
                                    <div>{{slotProps.option}}</div>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="form-group">
                        <label> {{ $t('AppOperatorsForm.Selecione o beacon') }} </label>
                        <Dropdown v-model="form.beacon_id" :options="beacons" :optionDisabled="isBeaconDisabled" filter
                                  :filterPlaceholder="$t('AppOperatorsForm.Procurar')" showClear optionLabel="mac_address"
                                  optionValue="beacon_id" style="width: 100%"/>
                    </div>
                    <div class="form-group d-flex justify-content-between flex-row-reverse">
                        <app-button class="col-12 col-lg-3 btn-sucess size" type="primary" @handleClick="validateForm">
                            {{ $t('AppOperatorsForm.Salvar') }}
                        </app-button>
                        <app-button v-if="!creating" class="col-12 col-lg-4 btn-danger size" type="primary"
                                    @handleClick="openRemoveDialog">
                            {{ $t('AppOperatorsForm.Remover motorista') }}
                        </app-button>
                    </div>
            </div>
        </form>

        <Dialog :visible.sync="showRemoveDialog" :style="{width: '450px'}" :header="$t('AppOperatorsForm.Atenção')" modal>
            {{ $t('AppOperatorsForm.Você tem certeza que deseja remover este operador?') }}
            <template #footer>
                <Button :label="$t('AppOperatorsForm.Cancelar')" icon="pi pi-times" class="p-button-text"
                        @click="showRemoveDialog = false"/>
                <Button :label="$t('AppOperatorsForm.Salvar')" icon="pi pi-check" class="p-button-text"
                        @click="removeOperator"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import Dropdown from 'primevue/dropdown';

import {states} from "@/constants/brazilianStatesWithCities";
import {required} from "vuelidate/lib/validators";

import BeaconsService from "../../../services/BeaconsService";
import OrganizationsService from "../../../services/OrganizationsService";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
    data() {
        return {
            isStateSelected: null,
            statesAndCities: states,
            originalBeaconId: null,
            beaconsService: null,
            organizationsService: null,
            link_id: null,
            cities: [],
            organizations: [],
            form: {
                first_name: null,
                last_name: null,
                identification: null,
                phone: null,
                state: [],
                city: "",
                beacon_id: null
            },
            beacons: [],
            selectedOrg: null,
            storedChosenOptions: {},
            showRemoveDialog: false
        }
    },
    props: {
        edit: {
            type: Object
        },
        creating: {
            type: Boolean
        }
    },
    components: {
        Button, Dialog, AppButton, AppInput, Dropdown
    },
    watch: {
        edit: function (val) {
            if (!val.state) {
                this.isStateSelected = false
                this.form.city = null
                this.form.state = null
            } else {
                this.isStateSelected = true
            }

            if (val.first_name) {
                this.form.first_name = val.first_name;
            }
            if (val.last_name) {
                this.form.last_name = val.last_name;
            }
            if (val.identification) {
                this.form.identification = val.identification;
            }
            if (val.phone) {
                this.form.phone = val.phone;
            }
            if (val.state) {
                this.selectStateByCode(val.state)
            }
            if (val.city) {
                this.form.city = val.city;
            }
            if (val.beacon_id) {
                this.form.beacon_id = val.beacon_id;
                this.originalBeaconId = val.beacon_id;
            }
            if (val.link_id) {
                this.form.link_id = val.link_id;
            }
        }
    },
    mounted() {
        this.beaconsService = new BeaconsService();
        this.organizationsService = new OrganizationsService();

        this.getOrganizations();
    },
    methods: {
        clearOrDisableCities() {
            this.form.city = null

            this.isStateSelected = this.form.state != null;
        },
        isBeaconDisabled(beacon) {
            if (beacon.beacon_id === this.originalBeaconId) {
                return false
            }

            return beacon.disabled
        },
        getOrganizations() {
            this.organizationsService.getAllV3('OPERATORS')
                .then((results) => {
                    this.organizations = results;
                    this.loadFilteredOptions();
                })
                .catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperators.Não foi possivel completar a operação'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperators.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                    console.log(error)
                })
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.organizations.filter(a => this.storedChosenOptions['clients'].some(b => a.id === b.id))[0];
            this.getBeacons(this.selectedOrg);
        },
        getBeacons() {
            this.beaconsService.getAllBeaconsByOrgId(this.selectedOrg.id)
                .then((results) => {
                    let beaconsFound = results.filter((beacon) => beacon.type === 'OPERATOR')
                    this.getBeaconsLinkByOrganization(beaconsFound);
                })
                .catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperators.Não foi possivel completar a operação'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperators.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                });
        },
        getBeaconsLinkByOrganization(organizationBeacons) {
            let beacon_info = [];
            this.beaconsService.getBeaconsLinksByOrgId(this.selectedOrg.id)
                .then((results) => {
                    organizationBeacons.forEach(element => {
                        let disabled = results.some(link => link.mac_address === element.mac_address);

                        beacon_info.push({
                            mac_address: element.mac_address,
                            beacon_id: element.id,
                            disabled: disabled
                        })
                    });

                    this.beacons = beacon_info;
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperators.Não foi possivel completar a operação'),
                        life: 5000
                    });
                });
        },
        selectStateByCode(code) {
            for (let i = 0; i < this.statesAndCities.length; i++) {
                if (code === this.statesAndCities[i].stateCode) {
                    this.form.state = this.statesAndCities[i];
                    break;
                }
            }
        },
        validateForm() {
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppOperatorsForm.Por favor preencha todos os campos obrigatórios'),
                    life: 5000
                });
                return;
            }

            if (this.form.state) {
                this.form.state = this.form.state.stateCode;
            }

            if (this.creating) {
                this.$emit('handleCreate', this.form);
                return;
            }

            this.$emit('handleUpdate', this.form, this.originalBeaconId, this.$route.params.id);
        },
        openRemoveDialog() {
            if (this.originalBeaconId && !this.form.beacon_id) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppOperatorsForm.Não é possível remover um operador associado a um beacon'),
                    detail: this.$t('AppOperatorsForm.É necessário remover o link e salvar a modificação antes de remover o operador'),
                    life: 5000
                });
                return;
            }

            if (this.originalBeaconId) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppOperatorsForm.Não é possível remover um operador associado a um beacon'),
                    life: 5000
                });
                return;
            }

            this.showRemoveDialog = true;
        },
        removeOperator() {
            this.$emit('handleRemove', this.$route.params.id);
        }
    },
    computed: {
        citiesFromState() {
            return this.form.state ? this.form.state.cities : [];
        }
    },
    validations: {
        form: {
            first_name: {required},
            last_name: {required}
        }
    }
}
</script>

<style scoped type="scss">

label {
    margin-bottom: 0;
}

.title {
    border-bottom: 0.5px #666666 solid;
    color: #666666;
    padding-bottom: 15px;
    padding-top: 5px;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
}

</style>